import { render } from "./PdfReader.vue?vue&type=template&id=09799b1a"
import script from "./PdfReader.vue?vue&type=script&lang=js"
export * from "./PdfReader.vue?vue&type=script&lang=js"

import "./PdfReader.vue?vue&type=style&index=0&id=09799b1a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__